import { CONSENT_FIRST_TIME_ZONES } from './constants.ts';

/**
 * Whether the browser's time zone places the visitor in Germany or France, where nothing may reach OpenPanel before
 * statistics consent. Read offline from `Intl`; travellers and VPN users can slip through either way (accepted).
 */
export const isConsentFirstRegion = () =>
    CONSENT_FIRST_TIME_ZONES.includes(Intl.DateTimeFormat().resolvedOptions().timeZone);
